export enum KeyboardShortcutAction {
	Save = 'Save',
	CodeResponsive = 'CodeResponsive',
	CodeNonResponsive = 'CodeNonResponsive',
	PreviousDocument = 'PreviousDocument',
	NextDocument = 'NextDocument',
	DocumentAbove = 'DocumentAbove',
	DocumentBelow = 'DocumentBelow',
	DocumentAboveSkipAttachment = 'DocumentAboveSkipAttachment',
	DocumentBelowSkipAttachment = 'DocumentBelowSkipAttachment',
	Exit = 'Exit'
}
